(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const overlay = document.querySelector('[data-cart-drawer-overlay]');
    const find = (selector) => drawer.querySelector(selector);
    const el = {
      title: find('[data-cart-drawer-title]'),
      close: find('[data-cart-drawer-close]'),
      body: find('[data-cart-drawer-body]'),
      status: find('[data-cart-drawer-status]'),
      error: find('[data-cart-drawer-error]'),
      empty: find('[data-cart-drawer-empty]'),
      items: find('[data-cart-drawer-items]'),
      footer: find('[data-cart-drawer-footer]'),
      shipping: find('[data-cart-drawer-shipping]'),
      shippingText: find('[data-cart-drawer-shipping-text]'),
      shippingFill: find('[data-cart-drawer-shipping-fill]'),
      upsell: find('[data-cart-drawer-upsell]'),
      upsellHeading: find('[data-cart-drawer-upsell-heading]'),
      upsellNote: find('[data-cart-drawer-upsell-note]'),
      upsellButton: find('[data-cart-drawer-upgrade]'),
      upsellError: find('[data-cart-drawer-upsell-error]'),
      saving: find('[data-cart-drawer-saving]'),
      savingAmount: find('[data-cart-drawer-saving-amount]'),
      delivery: find('[data-cart-drawer-delivery]'),
      deliveryLabel: find('[data-cart-drawer-delivery-label]'),
      deliveryValue: find('[data-cart-drawer-delivery-value]'),
      totalLabel: find('[data-cart-drawer-total-label]'),
      total: find('[data-cart-drawer-subtotal]'),
      checkoutForm: find('[data-cart-drawer-checkout-form]'),
      checkout: find('[data-cart-drawer-checkout]'),
    };

    const freeThreshold = parseInt(drawer.dataset.freeThreshold, 10) || 0;
    const freeInclusive = drawer.dataset.freeInclusive === 'true';
    const inGB = drawer.dataset.countryGb === 'true';
    const ukDeliveryFee = parseInt(drawer.dataset.ukDeliveryFee, 10) || 0;
    // getAttribute, not dataset: "-4" is not camel-cased, so dataset has no pack4Price.
    const defaultPack4 = parseInt(drawer.getAttribute('data-pack-4-price'), 10) || 0;
    const defaultPack6 = parseInt(drawer.getAttribute('data-pack-6-price'), 10) || 0;
    const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
    const SOURCE = 'cart-drawer';

    // Icons come from snippets/icon.liquid; the text glyphs are the fallback.
    const icons = { minus: '−', plus: '+' };
    drawer.querySelectorAll('template[data-cart-drawer-icon]').forEach((template) => {
      const html = template.innerHTML.trim();
      if (html.includes('<svg') && !html.includes('Liquid error')) {
        icons[template.getAttribute('data-cart-drawer-icon')] = html;
      }
    });

    let lastCart = null;
    let lastFocus = null;
    let isOpen = false;
    let busy = false;
    let submitting = false;
    let closeTimer = null;
    let requestId = 0;
    let pendingFocus = null;
    let inerted = [];

    const routeRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const escapeHTML = (value) =>
      String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    // Labels come from the `t` filter in data attributes, so they read back as plain text.
    const label = (name) => drawer.getAttribute(`data-label-${name}`) || '';

    const fill = (template, values) =>
      String(template || '').replace(/\[([a-z_]+)\]/g, (match, key) =>
        Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match
      );

    function money(cents) {
      const currency =
        (lastCart && lastCart.currency) ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        'GBP';
      const value = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency }).format(value);
      } catch (error) {
        return `${currency} ${value.toFixed(2)}`;
      }
    }

    function requestError(response, body) {
      const error = new Error(`Cart request failed with status ${response.status}`);
      error.description = (body && (body.description || body.message)) || '';
      return error;
    }

    // Pence still needed for free delivery. "Over £30" needs a penny more than "£30 or more".
    function freeDeliveryGap(total) {
      if (!freeThreshold) return 0;
      return Math.max(0, freeThreshold - total + (freeInclusive ? 0 : 1));
    }

    // Display-only pack prices: the page's funnel buy box when it has one, else the defaults.
    function packs() {
      let pack4 = defaultPack4;
      let pack6 = defaultPack6;
      const root = document.querySelector('[data-funnel-root]');
      if (root) {
        const rootPack4 = parseInt(root.getAttribute('data-pack-4-price'), 10);
        const rootPack6 = parseInt(root.getAttribute('data-pack-6-price'), 10);
        if (rootPack4 > 0 && rootPack6 > rootPack4) {
          pack4 = rootPack4;
          pack6 = rootPack6;
        }
      }
      if (!(pack4 > 0) || !(pack6 > pack4)) return null;
      return { pack4, pack6, sixFree: freeThreshold > 0 && freeDeliveryGap(pack6) === 0 };
    }

    // True when 4 pairs cost exactly the 4-pack price, so the pack arithmetic holds.
    // A discount code or a currency conversion breaks it, and the copy then quotes no prices.
    function isPlainFourPack(cart, packPrices) {
      return Boolean(packPrices) && cart.item_count === 4 && Number(cart.total_price) === packPrices.pack4;
    }

    /* ───── Free delivery bar ───── */

    // Free delivery is measured before discount codes, so an athlete or
    // affiliate code never takes a 6-pair pack out of free delivery.
    function deliveryBasis(cart) {
      const total = Number(cart && cart.total_price) || 0;
      if (!cart || !Array.isArray(cart.items)) return total;
      const codeTotal = discountSummary(cart).codes.reduce((sum, entry) => sum + (Number(entry.amount) || 0), 0);
      return total + codeTotal;
    }

    function renderShipping(cart) {
      if (!el.shipping) return;
      const total = deliveryBasis(cart);
      if (!freeThreshold || total <= 0) {
        el.shipping.hidden = true;
        return;
      }
      const gap = freeDeliveryGap(total);
      const packPrices = packs();
      let text;
      if (gap === 0) {
        text = label('free-unlocked');
      } else if (isPlainFourPack(cart, packPrices) && packPrices.sixFree) {
        text = fill(label('free-pairs'), { amount: money(gap), quantity: 2 });
      } else {
        text = fill(label('free-gap'), { amount: money(gap) });
      }
      if (el.shippingText) el.shippingText.textContent = text;
      if (el.shippingFill) {
        const percent = gap === 0 ? 100 : Math.min(100, Math.round((total / freeThreshold) * 100));
        el.shippingFill.style.width = `${percent}%`;
      }
      el.shipping.hidden = false;
    }

    // product-secondary calls a global updateShippingBar(totalPrice) on load.
    window.updateShippingBar = (total) => {
      renderShipping(Object.assign({ item_count: 0 }, lastCart || {}, { total_price: Number(total) || 0 }));
    };

    /* ───── Line items ───── */

    function imageUrl(url, width) {
      if (!url) return '';
      return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
    }

    function variantText(item) {
      if (item.product_has_only_default_variant) return '';
      const options = (item.options_with_values || [])
        .filter((option) => option && option.value && option.value !== 'Default Title')
        .map((option) => (option.name ? `${option.name} ${option.value}` : option.value));
      if (options.length) return options.join(' · ');
      return item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    }

    function itemHTML(item) {
      // Product titles carry an SEO tail after " | "; the basket shows the name.
      const title = (item.product_title || item.title || '').split(' | ')[0];
      const url = escapeHTML(item.url || '#');
      const image = item.featured_image && item.featured_image.url ? imageUrl(item.featured_image.url, 144) : '';
      const variant = variantText(item);
      const plan =
        item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
          ? item.selling_plan_allocation.selling_plan.name
          : '';
      const discounted = Number(item.original_line_price) > Number(item.final_line_price);

      let html = `<li class="cart-drawer__item" data-line-key="${escapeHTML(item.key)}" data-line-quantity="${Number(item.quantity) || 0}">`;
      html += `<a class="cart-drawer__item-image" href="${url}" tabindex="-1" aria-hidden="true">`;
      if (image) html += `<img src="${escapeHTML(image)}" alt="" width="72" height="72" loading="lazy">`;
      html += '</a><div class="cart-drawer__item-details"><div class="cart-drawer__item-top">';
      html += `<a class="cart-drawer__item-title" href="${url}">${escapeHTML(title)}</a>`;
      html += '<span class="cart-drawer__item-price">';
      if (discounted) {
        html += `<span class="visually-hidden">${escapeHTML(label('price-before'))}</span><s>${escapeHTML(money(item.original_line_price))}</s>`;
        html += `<span class="visually-hidden">${escapeHTML(label('price-now'))}</span>`;
      }
      html += `<span>${escapeHTML(money(item.final_line_price))}</span></span></div>`;
      if (variant) html += `<p class="cart-drawer__item-variant">${escapeHTML(variant)}</p>`;
      if (plan) {
        html += '<div class="cart-drawer__subscription">';
        html += `<span class="cart-drawer__subscription-badge">${escapeHTML(drawer.dataset.subscriptionLabel || '')}</span>`;
        html += `<p class="cart-drawer__item-selling-plan">${escapeHTML(plan)}</p>`;
        html += `<p class="cart-drawer__subscription-note">${escapeHTML(drawer.dataset.subscriptionNote || '')}</p>`;
        html += '</div>';
      }
      html += '<div class="cart-drawer__item-actions">';
      html += `<div class="cart-drawer__stepper" role="group" aria-label="${escapeHTML(fill(label('quantity'), { title }))}">`;
      html += `<button type="button" class="cart-drawer__step" data-line-action="decrease" aria-label="${escapeHTML(fill(label('decrease'), { title }))}">${icons.minus}</button>`;
      html += `<span class="cart-drawer__qty">${Number(item.quantity) || 0}</span>`;
      html += `<button type="button" class="cart-drawer__step" data-line-action="increase" aria-label="${escapeHTML(fill(label('increase'), { title }))}">${icons.plus}</button>`;
      html += '</div>';
      html += `<button type="button" class="cart-drawer__remove" data-line-action="remove" aria-label="${escapeHTML(fill(label('remove-label'), { title }))}">${escapeHTML(label('remove'))}</button>`;
      html += '</div></div></li>';
      return html;
    }

    /* ───── Discounts, delivery and total ───── */

    // Discount codes get their own rows; every other discount (the automatic pack
    // discount) is the "Pack saving" line, as before.
    function discountSummary(cart) {
      const codes = [];
      const byCode = new Map();
      let automatic = 0;
      let allocated = false;

      const codeEntry = (code) => {
        const id = String(code).toLowerCase();
        if (!byCode.has(id)) {
          const entry = { code: String(code), amount: 0 };
          byCode.set(id, entry);
          codes.push(entry);
        }
        return byCode.get(id);
      };

      const add = (application, amount) => {
        const value = Number(amount) || 0;
        if (!application || value <= 0) return;
        allocated = true;
        if (application.type === 'discount_code') {
          codeEntry(application.title || application.key || '').amount += value;
        } else {
          automatic += value;
        }
      };

      cart.items.forEach((item) => {
        (item.line_level_discount_allocations || []).forEach((allocation) => {
          add(allocation.discount_application, allocation.amount);
        });
      });
      (cart.cart_level_discount_applications || []).forEach((application) => {
        add(application, application.total_allocated_amount);
      });

      if (!allocated) {
        automatic =
          cart.total_discount > 0
            ? cart.total_discount
            : Math.max(0, (Number(cart.original_total_price) || 0) - (Number(cart.total_price) || 0));
      }

      // A code that applies but has nothing to take off the basket yet, such as free delivery.
      (cart.discount_codes || []).forEach((entry) => {
        if (entry && entry.applicable && entry.code) codeEntry(entry.code);
      });

      return { automatic, codes };
    }

    function renderSummary(cart) {
      const { automatic, codes } = discountSummary(cart);

      if (el.saving && el.savingAmount) {
        el.saving.hidden = !(automatic > 0);
        el.savingAmount.textContent = `−${money(automatic)}`;
      }

      drawer.querySelectorAll('[data-cart-drawer-code]').forEach((row) => row.remove());
      if (el.delivery && codes.length) {
        const rows = codes
          .map((entry) => {
            const value = entry.amount > 0 ? `−${money(entry.amount)}` : label('code-applied');
            return `<div class="cart-drawer__row cart-drawer__row--code" data-cart-drawer-code><dt>${escapeHTML(fill(label('code'), { code: entry.code }))}</dt><dd>${escapeHTML(value)}</dd></div>`;
          })
          .join('');
        el.delivery.insertAdjacentHTML('beforebegin', rows);
      }

      let total = Number(cart.total_price) || 0;
      if (inGB) {
        const free = freeThreshold > 0 && freeDeliveryGap(deliveryBasis(cart)) === 0;
        if (el.deliveryLabel) el.deliveryLabel.textContent = label('delivery-uk');
        if (el.deliveryValue) el.deliveryValue.textContent = free ? label('delivery-free') : money(ukDeliveryFee);
        if (!free) total += ukDeliveryFee;
        if (el.totalLabel) el.totalLabel.textContent = label('total');
      } else {
        // EU and international rates depend on the address, so they stay at checkout.
        if (el.deliveryLabel) el.deliveryLabel.textContent = label('delivery');
        if (el.deliveryValue) el.deliveryValue.textContent = label('delivery-checkout');
        if (el.totalLabel) el.totalLabel.textContent = label('subtotal');
      }
      if (el.total) el.total.textContent = money(total);
    }

    /* ───── 4 to 6 pairs upgrade ───── */

    // Two more pairs of the variant the basket holds most of (ties go to the first),
    // added to that variant's biggest line.
    function upgradeLine(cart) {
      const items = cart.items.filter((item) => !item.gift_card);
      const totals = new Map();
      items.forEach((item) => totals.set(item.variant_id, (totals.get(item.variant_id) || 0) + item.quantity));
      let variantId = null;
      totals.forEach((quantity, id) => {
        if (variantId === null || quantity > totals.get(variantId)) variantId = id;
      });
      let line = null;
      items.forEach((item) => {
        if (item.variant_id === variantId && (!line || item.quantity > line.quantity)) line = item;
      });
      return line;
    }

    function renderUpsell(cart) {
      if (!el.upsell || !el.upsellButton) return;
      const packPrices = packs();
      const line = cart.item_count === 4 ? upgradeLine(cart) : null;
      if (!packPrices || !line) {
        el.upsell.hidden = true;
        return;
      }

      const extra = packPrices.pack6 - packPrices.pack4;
      let note;
      let button;
      if (isPlainFourPack(cart, packPrices)) {
        const net = extra - ukDeliveryFee;
        let deliveryBecomesFree = false;
        if (inGB && packPrices.sixFree && ukDeliveryFee > 0 && net > 0) {
          deliveryBecomesFree = freeDeliveryGap(cart.total_price) > 0;
        }
        note = deliveryBecomesFree
          ? fill(label('upgrade-note-free'), { amount: money(extra), pairs: 2, net: money(net) })
          : fill(label('upgrade-note'), { amount: money(extra), pairs: 2 });
        button = fill(label('upgrade-button'), { quantity: 6, amount: money(extra) });
      } else {
        note = fill(label('upgrade-note-plain'), { pairs: 2 });
        button = fill(label('upgrade-button-plain'), { quantity: 6 });
      }

      if (el.upsellHeading) el.upsellHeading.textContent = fill(label('upgrade-heading'), { quantity: 6 });
      if (el.upsellNote) el.upsellNote.textContent = note;
      el.upsellButton.textContent = button;
      el.upsellButton.dataset.lineKey = line.key;
      if (el.upsellError) el.upsellError.hidden = true;
      el.upsell.hidden = false;
    }

    /* ───── Render ───── */

    function renderCart(cart) {
      if (!cart || !Array.isArray(cart.items) || !el.items) return;
      lastCart = cart;
      const count = Number(cart.item_count) || 0;
      const hasItems = count > 0;

      if (el.title) {
        el.title.textContent = hasItems
          ? fill(label(count === 1 ? 'title-one' : 'title-other'), { quantity: count })
          : label('title');
      }

      el.items.innerHTML = hasItems
        ? cart.items
            .map((item) => {
              try {
                return itemHTML(item);
              } catch (error) {
                console.error('Error rendering cart item:', error);
                return '';
              }
            })
            .join('')
        : '';

      if (el.empty) el.empty.hidden = hasItems;
      if (el.footer) el.footer.hidden = !hasItems;

      renderShipping(cart);
      renderSummary(cart);
      renderUpsell(cart);
      if (busy) setBusy(true);
      restoreFocus();

      document.dispatchEvent(new CustomEvent('cart:rendered', { detail: { cart } }));
    }

    function setBusy(state) {
      busy = state;
      if (el.body) el.body.setAttribute('aria-busy', String(state));
      // aria-disabled rather than disabled, so the pressed button keeps focus.
      drawer.querySelectorAll('[data-line-action], [data-cart-drawer-upgrade], [data-cart-drawer-checkout]').forEach((button) => {
        if (state) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
      });
    }

    function restoreFocus() {
      if (!pendingFocus || !isOpen) {
        pendingFocus = null;
        return;
      }
      const { key, action, index } = pendingFocus;
      pendingFocus = null;
      const lines = Array.from(el.items.querySelectorAll('[data-line-key]'));
      const line = lines.find((node) => node.getAttribute('data-line-key') === key);
      let target = line ? line.querySelector(`[data-line-action="${action}"]`) : null;
      if (!target && lines.length) {
        target = lines[Math.min(index, lines.length - 1)].querySelector('.cart-drawer__item-title');
      }
      if (!target) target = el.close;
      if (target) target.focus();
    }

    function announce(message) {
      if (!el.status) return;
      el.status.textContent = '';
      requestAnimationFrame(() => {
        el.status.textContent = message;
      });
    }

    function showError(message) {
      if (!el.error) return;
      el.error.textContent = message || '';
      el.error.hidden = !message;
    }

    async function refresh() {
      const id = ++requestId;
      if (!lastCart && el.body) el.body.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${routeRoot()}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Cart fetch failed with status ${response.status}`);
        const cart = await response.json();
        if (id !== requestId) return;
        showError('');
        renderCart(cart);
      } catch (error) {
        if (id !== requestId) return;
        console.error('Cart fetch error:', error);
        showError(label('load-error'));
      } finally {
        if (!busy && el.body) el.body.setAttribute('aria-busy', 'false');
      }
    }

    /* ───── Quantity and remove ───── */

    async function changeLine(key, quantity, action, title, index) {
      if (busy) return;
      setBusy(true);
      showError('');
      const id = ++requestId;
      try {
        const response = await fetch(`${routeRoot()}cart/change.js`, {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ id: key, quantity }),
        });
        const cart = await response.json().catch(() => ({}));
        if (!response.ok) throw requestError(response, cart);
        if (id !== requestId) return;

        pendingFocus = { key, action, index };
        renderCart(cart);

        const line = cart.items.find((item) => item.key === key);
        if (quantity > 0 && line && line.quantity < quantity) {
          showError(fill(label('quantity-limited'), { quantity: line.quantity }));
        }
        announce(quantity === 0 ? fill(label('removed'), { title }) : label('updated'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: SOURCE } }));
      } catch (error) {
        console.error('Cart change error:', error);
        showError(error.description || label('update-error'));
      } finally {
        setBusy(false);
      }
    }

    if (el.items) {
      el.items.addEventListener('click', (event) => {
        const button = event.target.closest('[data-line-action]');
        if (!button || busy) return;
        const line = button.closest('[data-line-key]');
        if (!line) return;
        const current = parseInt(line.getAttribute('data-line-quantity'), 10) || 0;
        const action = button.getAttribute('data-line-action');
        let quantity = 0;
        if (action === 'increase') quantity = current + 1;
        if (action === 'decrease') quantity = Math.max(0, current - 1);
        const titleEl = line.querySelector('.cart-drawer__item-title');
        const index = Array.prototype.indexOf.call(el.items.children, line);
        changeLine(line.getAttribute('data-line-key'), quantity, action, titleEl ? titleEl.textContent : '', index);
      });
    }

    /* ───── Upgrade ───── */

    async function upgrade() {
      if (busy || !lastCart) return;
      const key = el.upsellButton.dataset.lineKey;
      const line = lastCart.items.find((item) => item.key === key);
      if (!line) return;

      // The same properties and selling plan put the pairs on that same line.
      const item = { id: line.variant_id, quantity: 2 };
      if (line.properties && typeof line.properties === 'object' && Object.keys(line.properties).length) {
        item.properties = line.properties;
      }
      if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) {
        item.selling_plan = line.selling_plan_allocation.selling_plan.id;
      }

      setBusy(true);
      el.upsellButton.textContent = label('upgrading');
      if (el.upsellError) el.upsellError.hidden = true;
      try {
        const response = await fetch(`${routeRoot()}cart/add.js`, {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ items: [item] }),
        });
        const body = await response.json().catch(() => ({}));
        if (!response.ok) throw requestError(response, body);

        document.dispatchEvent(
          new CustomEvent('product:add_to_cart', {
            bubbles: true,
            detail: {
              option: 'drawer-upgrade-6',
              sellingPlan: item.selling_plan || null,
              displayValue: '',
              currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
              items: (body && body.items) || [],
            },
          })
        );

        pendingFocus = { key, action: 'increase', index: 0 };
        await refresh();
        announce(label('updated'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: lastCart, source: SOURCE } }));
      } catch (error) {
        console.error('Cart upgrade error:', error);
        if (lastCart) renderUpsell(lastCart);
        if (el.upsellError) {
          el.upsellError.textContent = error.description || label('upgrade-error');
          el.upsellError.hidden = false;
        }
      } finally {
        setBusy(false);
      }
    }

    if (el.upsellButton) el.upsellButton.addEventListener('click', upgrade);

    /* ───── Checkout ───── */

    if (el.checkoutForm) {
      el.checkoutForm.addEventListener('submit', (event) => {
        // Not `disabled`: a disabled submitter drops name="checkout" from the post.
        if (busy || submitting) {
          event.preventDefault();
          return;
        }
        submitting = true;
        if (el.checkout) el.checkout.setAttribute('aria-busy', 'true');
      });
    }

    /* ───── Open and close ───── */

    // Everything outside the drawer is inert while it is open, which keeps focus inside it.
    function setBackgroundInert(state) {
      if (state) {
        inerted = Array.from(document.body.children).filter(
          (node) => node !== drawer && node !== overlay && !node.inert && !['SCRIPT', 'STYLE', 'TEMPLATE', 'LINK'].includes(node.tagName)
        );
        inerted.forEach((node) => {
          node.inert = true;
        });
      } else {
        inerted.forEach((node) => {
          node.inert = false;
        });
        inerted = [];
      }
    }

    function openDrawer() {
      clearTimeout(closeTimer);
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      if (overlay) overlay.hidden = false;
      setBackgroundInert(true);
      document.documentElement.style.overflow = 'hidden';
      // Flush styles so the slide-in transition runs from the off-screen position.
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      if (el.close) el.close.focus({ preventScroll: true });
    }

    function closeDrawer() {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      setBackgroundInert(false);
      document.documentElement.style.overflow = '';
      // Focus goes back to whatever opened the drawer.
      if (lastFocus && document.contains(lastFocus) && typeof lastFocus.focus === 'function') {
        lastFocus.focus({ preventScroll: true });
      }
      lastFocus = null;
      closeTimer = setTimeout(() => {
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
      }, 350);
    }

    if (el.close) el.close.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen) closeDrawer();
    });

    document.addEventListener('cart:drawer:open', () => {
      refresh();
      openDrawer();
    });

    document.addEventListener('cart:updated', (event) => {
      if (event.detail && event.detail.source === SOURCE) return;
      refresh();
    });

    // Back/forward cache: the page comes back as it was, so bring the basket up to date.
    window.addEventListener('pageshow', (event) => {
      submitting = false;
      if (el.checkout) el.checkout.removeAttribute('aria-busy');
      if (event.persisted) refresh();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.getElementById('quick-view-modal');
    var overlay = modal ? modal.querySelector('[data-quick-view-overlay]') : null;
    var closeBtn = modal ? modal.querySelector('[data-quick-view-close]') : null;

    if (!modal) return;

    function closeModal() {
      modal.close();
    }

    function setStockBadge(stockState) {
      modal.querySelectorAll('[data-quick-view-stock-badge]').forEach(function (badge) {
        badge.hidden = badge.getAttribute('data-quick-view-stock-badge') !== stockState;
      });
    }

    function openQuickView(productId, stockState) {
      fetch('/products/' + productId + '.json')
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var product = data.product;
          if (!product) return;

          var titleEl = modal.querySelector('[data-quick-view-title]');
          var typeEl = modal.querySelector('[data-quick-view-type]');
          var imageEl = modal.querySelector('[data-quick-view-image]');
          var priceEl = modal.querySelector('[data-quick-view-price]');
          var compareEl = modal.querySelector('[data-quick-view-price-compare]');
          var urlEl = modal.querySelector('[data-quick-view-url]');

          if (titleEl) titleEl.textContent = product.title;
          if (typeEl) typeEl.textContent = product.type || '';
          if (imageEl && product.featured_image) {
            imageEl.src = product.featured_image.src;
            imageEl.alt = product.title;
          }
          if (priceEl && product.variants && product.variants.length) {
            var price = (product.variants[0].price / 100).toFixed(2);
            priceEl.textContent = '£' + price;
          }
          if (compareEl && product.variants && product.variants[0].compare_at_price) {
            var comparePrice = (product.variants[0].compare_at_price / 100).toFixed(2);
            compareEl.textContent = '£' + comparePrice;
            compareEl.hidden = false;
          } else if (compareEl) {
            compareEl.hidden = true;
          }
          if (urlEl) urlEl.href = product.url;
          setStockBadge(stockState);

          modal.showModal();
        })
        .catch(function (e) {
          console.error('Quick view error:', e);
        });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.open) closeModal();
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view-open]');
      if (btn) {
        e.preventDefault();
        var productId = btn.getAttribute('data-quick-view-product-id');
        // Trimmed: the stock-state snippet renders with a surrounding line break.
        if (productId) openQuickView(productId, (btn.getAttribute('data-quick-view-stock') || '').trim());
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSizeGuideModal() {
      var modal = document.getElementById('size-guide-modal');
      if (!modal) return;
      var closeBtn = modal.querySelector('[data-size-guide-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.close();
      });
      document.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          modal.showModal();
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSizeGuideModal);
    } else {
      initSizeGuideModal();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ugc-grid-inline"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('.ugc-grid').forEach(function(section) {
      var sectionId = section.id.replace('ugc-grid-', '');
      var dialog = document.getElementById('ugc-lightbox-' + sectionId);
      var dataEl = section.querySelector('[data-ugc-data="' + sectionId + '"]');
      if (!dialog || !dataEl) return;

      var items;
      try { items = JSON.parse(dataEl.textContent); } catch(e) { return; }

      var mediaContainer = dialog.querySelector('.ugc-grid__lightbox-media');
      var authorEl = dialog.querySelector('.ugc-grid__lightbox-author');
      var captionEl = dialog.querySelector('.ugc-grid__lightbox-caption');
      var closeBtn = dialog.querySelector('.ugc-grid__lightbox-close');

      var isMobile = function() {
        return window.matchMedia('(max-width: 980px)').matches;
      };

      function openLightbox(index) {
        var item = items[index];
        if (!item) return;
        if (item.video) return;
        mediaContainer.innerHTML = '';
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.alt;
        mediaContainer.appendChild(img);
        authorEl.textContent = item.author;
        captionEl.textContent = item.caption || '';
        captionEl.style.display = item.caption ? '' : 'none';
        dialog.classList.remove('ugc-grid__lightbox--video-fullscreen');
        dialog.showModal();
      }

      function openVideoFullscreen(index) {
        var item = items[index];
        if (!item || !item.video) return;
        mediaContainer.innerHTML = '';
        var video = document.createElement('video');
        video.src = item.video;
        if (item.image) video.poster = item.image;
        video.controls = true;
        video.muted = false;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.className = 'ugc-grid__lightbox-video';
        mediaContainer.appendChild(video);
        authorEl.textContent = item.author;
        captionEl.textContent = item.caption || '';
        captionEl.style.display = item.caption ? '' : 'none';
        dialog.classList.add('ugc-grid__lightbox--video-fullscreen');
        dialog.showModal();
        video.play();
      }

      function closeLightbox() {
        var v = mediaContainer.querySelector('video');
        if (v) {
          v.pause();
          v.src = '';
        }
        mediaContainer.innerHTML = '';
        dialog.classList.remove('ugc-grid__lightbox--video-fullscreen');
        dialog.close();
      }

      function playVideoInPlace(btn, index) {
        var item = items[index];
        if (!item || !item.video) return;
        var media = btn.querySelector('.ugc-grid__media');
        if (!media) return;
        var existing = media.querySelector('.ugc-grid__inline-video');
        if (existing) {
          existing.play();
          return;
        }
        var video = document.createElement('video');
        video.className = 'ugc-grid__inline-video';
        video.src = item.video;
        if (item.image) video.poster = item.image;
        video.controls = true;
        video.muted = true;
        video.playsInline = true;
        video.preload = 'metadata';
        media.classList.add('ugc-grid__media--playing');
        media.appendChild(video);
        video.play();
      }

      section.querySelectorAll('.ugc-grid__item').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var index = parseInt(btn.getAttribute('data-ugc-index'), 10);
          if (items[index] && items[index].video) {
            if (isMobile()) {
              openVideoFullscreen(index);
            } else {
              playVideoInPlace(btn, index);
            }
            return;
          }
          openLightbox(index);
        });
      });

      closeBtn.addEventListener('click', closeLightbox);

      dialog.addEventListener('click', function(e) {
        if (e.target === dialog) closeLightbox();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
